"use client";

import Link from "next/link";
import Input from "@/components/ui/input";
import Label from "@/components/ui/label";
import { User } from "@/types";
import styles from "./HamburgerMenu.module.scss";
import { X_URL } from "@/const/serviceURL";

type Props = {
	user: User;
	isOpen: boolean;
	handleMenu: () => void;
	logout: () => void;
};

/**
 * ハンバーガーメニュー コンポーネント
 * @returns {JSX.Element} ハンバーガーメニュー コンポーネント
 */
export default function HamburgerMenu(props: Props) {
	const { user, isOpen, handleMenu, logout } = props;
	// スマホでログアウトした際は、ログアウトに加えて、メニューを閉じる必要がある。
	const onClick = () => {
		logout();
		handleMenu();
	};

	return (
		<>
			<div className={styles.humbergerMenu}>
				<Input
					type="checkbox"
					className={styles.menuButtonCheck}
					id="menuBtnCheck"
					checked={isOpen}
					onChange={handleMenu}
				/>
				<Label htmlFor="menuBtnCheck" className={styles.menuButton}>
					<span className={styles.span}></span>
				</Label>

				<nav className={styles.nav}>
					<ul className={styles.navList}>
						<li className={styles.navItem}>
							<Link href="/design" onClick={handleMenu}>
								新規作成
							</Link>
						</li>
						{user && (
							<li className={styles.navItem}>
								<Link href="/mydesign" onClick={handleMenu}>
									マイデザイン
								</Link>
							</li>
						)}
						{user ? (
							<li className={styles.navItem}>
								<a onClick={onClick}>ログアウト</a>
							</li>
						) : (
							<li className={styles.navItem}>
								<Link href="/login" onClick={handleMenu}>
									ログイン
								</Link>
							</li>
						)}
						<div className={styles.border}></div>
						<li className={styles.navItem}>
							<Link href="/legal/privacy" onClick={handleMenu}>
								プライバシーポリシー
							</Link>
						</li>
						<li className={styles.navItem}>
							<Link
								href="/legal/termsofservice"
								onClick={handleMenu}
							>
								利用規約
							</Link>
						</li>
						<li className={styles.navItem}>
							<Link href={X_URL} onClick={handleMenu}>
								お問い合わせ
							</Link>
						</li>
					</ul>
				</nav>
			</div>
		</>
	);
}
